// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6988f97e","453":"480434db","455":"99e8e914","977":"e2ae834d"}[chunkId] + ".chunk.js";
};